import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface EnrollmentKeyResponse {
  key: string;
}

@Injectable({
  providedIn: 'root',
})
export class DevicesEnrollmentKeyHttpService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _baseUrl = `${environment.services?.['ai-edge-manager']?.base_url}/${environment.services?.['ai-edge-manager']?.api_version}`;

  private _enrollmentKeyBaseUrl(platform: string): string {
    return `${this._baseUrl}/${platform}/enrollment-key`;
  }

  public createEnrollmentKey(platform: string, integrationId: string): Observable<EnrollmentKeyResponse> {
    return this._httpClient.post<EnrollmentKeyResponse>(this._enrollmentKeyBaseUrl(platform), { integrationId });
  }

  public getEnrollmentKey(platform: string, integrationId: string): Observable<EnrollmentKeyResponse> {
    const url = `${this._enrollmentKeyBaseUrl(platform)}?integrationId=${encodeURIComponent(integrationId)}`;
    return this._httpClient.get<EnrollmentKeyResponse>(url);
  }
}
